export default {
  tips: {
    mulStart:
      'The user journey is intended to have only one starting point, but currently, there are multiple.',
    ignoreAfterInstall:
      "If the user don't return within 25s after redirection, events after the redirect are not counted in the journey statistics.",
    greenPath: 'Green Path',
    greenPathDesc:
      '{greenPath} is the branch with the maximum flow; it is recommended to optimize.',
    flowsCount:
      'When multiple branches can be reached from one tracking point, the maximum flow branch refers to the branch with the highest number of users.',
    dataAnomaly:
      'Due to factors such as network latency, there may be an extremely small proportion of anomalies in journey data. It is recommended to focus more on overall trends and percentages when analyzing the data and to disregard these minor errors.',
    emptyNode: 'Custom tracking is not configured for this asset',
  },
  fields: {
    flows: 'Exit',
    duration: 'Duration',
    reach: 'Session',
    flowsNext: 'Exit to Next',
    loss: 'Drop Off',
    install: 'Redirect',
  },
  basicAction: {
    imp: 'Impression',
    gs: 'PL View',
    ws: 'Webviewshow',
  },
  actionBar: {
    exitFullScreen: 'Exit Fullscreen',
    FullScreen: 'Full Screen',
    adjustStage: 'Fit to canvas',
  },
  projectFilter: {
    journey: {
      emptyData:
        'No tracking points in the current project, another with data was auto-selected.',
    },
    scene: {
      emptyData:
        'No scenario split in the current project, another with data was auto-selected.',
    },
    template_name: 'Playable Templates',
    template_name_id: 'Playable Template ID',
    c_template_name: 'Creative Concept',
    c_template_name_id: 'Creative Concept ID',
    basic_id: 'Creative ID',
    mws_creative_name: 'Creative Name',
  },
}
